/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, userId: ZodTypes.Id });

export const GetOrganizationUser = {
  id: 'organization-user.get',
  tag: 'Organization',
  summary: 'Get organization user',
  description: 'Retrieve a user of an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user/${params.userId}`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            id: ZodTypes.Id,
            role: ZodTypes.RBAC.Organization.Roles,
            user: z.strictObject({
              id: ZodTypes.Id,
              authentication: z.discriminatedUnion('type', [
                z.strictObject({ type: z.literal('local') }),
                z.strictObject({ type: z.literal('oauth2'), oauth2Id: z.string(), provider: ZodTypes.OAuth2Providers }),
                z.strictObject({ type: z.literal('oidc'), oidcId: z.string(), groups: z.array(z.string()) }),
              ]),
              email: z.string().email(),
              firstName: z.string().min(1),
              middleName: z.string().min(1).nullable().optional(),
              lastName: z.string().min(1),
              verified: z.boolean(),
              phoneNationalNumber: z.string().min(1).nullable().optional(),
              phoneCountryCode: ZodTypes.Country.nullable().optional(),
              language: ZodTypes.Language,
            }),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
